(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function compactSizeChart() {
    if (!mobile.matches || !document.querySelector('.product-details')) return;
    document.querySelectorAll('[class*="ai-size-chart-trigger-"]').forEach(el => {
      const text = (el.textContent || '').trim();
      if (/view\s*size\s*chart/i.test(text)) el.textContent = 'Size Chart';
    });
  }

  function suppressOverlap() {
    if (!mobile.matches || !document.querySelector('.product-details')) return;
    document.querySelectorAll('body *').forEach(el => {
      const text = (el.textContent || '').trim();
      if (!/limited\s*time\s*10%/i.test(text) || text.length > 180) return;
      const style = getComputedStyle(el);
      if (style.position === 'fixed' || style.position === 'sticky') {
        el.classList.add('gpt-mobile-overlap-control');
      }
    });
  }

  function apply() {
    compactSizeChart();
    suppressOverlap();
  }

  function start() {
    apply();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
